/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CashRegisterService } from '../cash-register.service';
import { ICashRegisterClose } from '../cash-register.interface';
import { TokenService } from 'src/app/auth/services/token/token.service';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
@Component({
  selector: 'pg-cash-register-close',
  templateUrl: './cash-register-close.component.html'
})
export class CashRegisterCloseComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  constructor(
    private fb: FormBuilder,
    private serviceBase: CashRegisterService,
    private tokenService: TokenService
  ) {
    super('Cerrar Caja Registradora', serviceBase);
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      endingBalance: ['1.00', [Validators.required]]
    });
  }

  async onSubmit() {
    if (this.checkReadyToOpen()) {
      await this.updateItemWithoutId$(
        this.parseData(this.fg.value) as ICashRegisterClose
      );

      if (this.message.status === 200) {
        this.tokenService.setCanSale(false);
      }
    }
  }

  parseData(form) {
    return {
      endingBalance: form.endingBalance
    };
  }

  checkReadyToOpen() {
    return this.fg.value;
  }
}
